import{useSelector}from'react-redux';const useAntiforgeryToken=()=>{return useSelector(state=>state.antiforgeryToken||'');};export default useAntiforgeryToken;